import { createContext } from 'react'
import { ActionBarActionCallbackArgs } from './FullScreenStepperProps'

export interface FullScreenStepperContextValue extends ActionBarActionCallbackArgs {
  [key: string]: unknown
}

export const FullScreenStepperContext = createContext({} as FullScreenStepperContextValue)
